/* Vinette — cuenta atras, animaciones, galeria, selector de sets y barra fija. Sin dependencias.
   Todo lo visible (precios con moneda, nombres de set) llega ya formateado desde Liquid en data-*; aqui no se formatea dinero. */
// Cuenta atras: la fecha fin llega de Liquid (data-countdown, ISO con zona). Al llegar a cero se oculta; nunca se reinicia.
(function () {
  var els = document.querySelectorAll('[data-countdown]');
  if (!els.length) return;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var timer;
  function tick() {
    var now = Date.now(), live = 0;
    els.forEach(function (el) {
      var end = Date.parse(el.dataset.countdown);
      if (isNaN(end) || el.hidden) return;
      var s = Math.floor((end - now) / 1000);
      if (s <= 0) { el.hidden = true; return; }
      live++;
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      var t = el.querySelector('[data-cd-text]');
      if (t) t.textContent = (v.d ? v.d + 'd ' : '') + pad(v.h) + ':' + pad(v.m) + ':' + pad(v.s);
      el.querySelectorAll('[data-cd]').forEach(function (u) { u.textContent = pad(v[u.dataset.cd]); });
    });
    if (!live) clearInterval(timer);
  }
  tick();
  timer = setInterval(tick, 1000);
})();

// Aparicion suave al hacer scroll (fuera de la ficha de compra, que se ve al instante).
// Sin JS o con "reducir movimiento", todo se ve normal: el estado oculto solo existe con html.js (ver vinette.css).
(function () {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = '.section .eyebrow, .section h2, .story__img, .story__text, .story__btn, .banner__txt h2, .banner__txt p, .banner__btn, .compare, .guarantee, .rv-summary, .rv-card, .review';
  var els = document.querySelectorAll(sel);
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  els.forEach(function (el) {
    if (el.closest('[data-product-section]')) return;
    var sib = Array.prototype.indexOf.call(el.parentNode.children, el);
    el.classList.add('rv');
    el.style.transitionDelay = Math.min(sib, 4) * 90 + 'ms';
    el.addEventListener('transitionend', function clear() {  // que el retraso no afecte luego al hover
      el.style.transitionDelay = '';
      el.removeEventListener('transitionend', clear);
    });
    io.observe(el);
  });
})();

// Clips en video: cada <video data-clip> (snippets/scroll-seq) se descarga al acercarse, se reproduce una vez
// cuando su seccion esta a la vista y se queda en el ultimo plano. Al salir de pantalla se pausa y se rebobina,
// asi se repite si se vuelve. Aparece con un fundido sobre la foto, que sigue debajo mientras carga.
(function () {
  var vids = [].slice.call(document.querySelectorAll('video[data-clip]'));
  if (!vids.length) return;
  var raf = 0;
  vids.forEach(function (v) {
    v.muted = true;  // iOS solo deja reproducir solo si esta en silencio
    v.addEventListener('playing', function () { v.classList.add('is-ready'); });
    v.addEventListener('ended', function () { v.dataset.played = '1'; });
  });
  function check() {
    raf = 0;
    var vh = innerHeight;
    vids.forEach(function (v) {
      var r = v.parentNode.getBoundingClientRect();
      if (!v.src && r.top < vh * 2 && r.bottom > -vh) { v.src = v.dataset.src; v.preload = 'auto'; }  // una pantalla antes
      var seen = (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / Math.min(r.height, vh);
      if (seen > 0.4 && v.src && v.paused && !v.dataset.played) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      if (r.top >= vh || r.bottom <= 0) {                 // fuera de pantalla: listo para la proxima vez
        if (!v.paused) v.pause();
        if (v.dataset.played || v.currentTime > 0) { delete v.dataset.played; v.currentTime = 0; }
      }
    });
  }
  function kick() { if (!raf) raf = requestAnimationFrame(check); }
  addEventListener('scroll', kick, { passive: true });
  addEventListener('resize', kick);
  vids.forEach(function (v) { v.addEventListener('loadeddata', kick); });
  kick();
})();

(function () {
  var section = document.querySelector('[data-product-section]');
  if (!section) return;

  // Galeria: el carrusel es scroll-snap (se desliza con el dedo sin JS); aqui van flechas, puntos, miniaturas y zoom
  var gallery = section.querySelector('[data-gallery]');
  var track = gallery && gallery.querySelector('[data-track]');
  if (track) {
    var slides = track.children;
    var thumbs = gallery.querySelectorAll('.gallery__thumbs button');
    var dots = gallery.querySelectorAll('.gallery__dots i');
    var current = -1;
    var go = function (i, smooth) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    };
    var mark = function (i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (b, n) { b.setAttribute('aria-current', String(n === i)); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      var b = thumbs[i], box = b && b.parentNode;  // solo desplaza la fila de miniaturas, nunca la pagina
      if (box) box.scrollTo({ left: b.offsetLeft - (box.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
    };
    addEventListener('resize', function () { go(current, false); });
    track.addEventListener('scroll', function () {
      mark(Math.round(track.scrollLeft / track.clientWidth));
    }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.index, true); }); });
    var prev = gallery.querySelector('[data-prev]'), next = gallery.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1, true); }
    });
    go(+gallery.dataset.start || 0, false);
    mark(+gallery.dataset.start || 0);

    // Zoom al pasar el raton (solo raton, no tactil): la imagen sigue al cursor
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) {
      Array.prototype.forEach.call(slides, function (s) {
        var img = s.querySelector('img');
        if (!img) return;
        s.addEventListener('mousemove', function (e) {
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        s.addEventListener('mouseenter', function () { s.classList.add('is-zoom'); });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
      });
    }
  }

  // Sets (variantes): el radio name="id" ya es el dato del formulario; esto solo actualiza textos
  var sticky = document.getElementById('sticky');
  function sync(r) {
    document.querySelectorAll('[data-price]').forEach(function (el) {
      if (el.tagName !== 'INPUT') el.textContent = r.dataset.price;
    });
    var cmp = section.querySelector('.price [data-compare]');
    if (cmp) cmp.textContent = r.dataset.compare || '';
    document.querySelectorAll('.sticky [data-set]').forEach(function (el) { el.textContent = r.dataset.set; });
    if (window.history && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u);
    }
  }
  section.querySelectorAll('input[type=radio][name=id]').forEach(function (r) {
    r.addEventListener('change', function () { sync(r); });
  });
  var checked = section.querySelector('input[type=radio][name=id]:checked');
  if (checked) sync(checked);

  // Barra fija: visible cuando el boton principal esta fuera de pantalla (arriba o abajo)
  var cta = document.getElementById('mainCta');
  if (sticky && cta) {
    var btn = sticky.querySelector('button');
    var check = function () {
      var r = cta.getBoundingClientRect(), on = r.bottom < 0 || r.top > innerHeight;
      if (sticky.classList.contains('is-on') === on) return;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', String(!on));
      if (btn) btn.tabIndex = on ? 0 : -1;
    };
    addEventListener('scroll', check, { passive: true });
    addEventListener('resize', check);
    check();
  }
})();
